module.exports = __webpack_public_path__ + "img/shape-content-contact-desktop.aa80648549619f872ed41bab80cdb4ff.svg";